import axios from 'axios'     //引入
import { Dialog } from 'vant';
import router from './../router'
import store from '@/store/index.js'
import { getToken, clearAuthStorage } from '@/utils/auth'

const DEFAULT_API_ORIGIN = 'https://www.manlianguoji.vip'
let baseURL = DEFAULT_API_ORIGIN

sessionStorage.setItem("baseURL", baseURL)

//这一步的目的是判断出当前是开发环境还是生成环境，方法不止一种，达到目的就行
if(process.env.NODE_ENV=="development"){
  baseURL=''
}

let config = {
    baseURL: baseURL,
    timeout: 10000       //设置最大请求时间，减少等待时间
}
const _axios = axios.create(config)

/* 请求拦截器（请求之前的操作） */
_axios.interceptors.request.use(
    config => {
        //如果有需要在这里开启请求时的loading动画效果
        // Authorization:Bearer hPxf6a8TQnCkExTYxceujYgXoW9GXB9909zsZtpvabw6yO9ngcMVKgLx4mzD
        let token = getToken()
        config.headers.Authorization = 'Bearer ' + token;
        if (token) config.headers['X-Api-Token'] = token
        return config;
    },
    err => Promise.reject(err)
);

/* 请求之后的操作 */
_axios.interceptors.response.use(
    res => {
        //在这里关闭请求时的loading动画效果
        //这里用于处理返回的结果，比如如果是返回401无权限，可能会是跳回到登录页的操作，结合自己的业务逻辑写

        if (res.data && res.data.code === 401 && !(res.config && res.config.skipAuthLogout)) {
            const sent = (res.config.headers && (res.config.headers.Authorization || res.config.headers.authorization)) || ''
            const sentToken = String(sent).replace(/^Bearer\s+/i, '')
            const current = getToken()
            // 没带 token，或已经换成新 token 的旧请求，不能把当前登录清掉
            if (sentToken && current && sentToken === current) {
                confirmLogout(current)
            }
        }
        return res;
    },
    err => {
        if (err) {
            //在这里关闭请求时的loading动画效果
            // Toast("请求网络失败")
        }
        return Promise.reject(err);
    }
);

let logoutCheck = null

function confirmLogout(expectedToken) {
    if (logoutCheck) return
    logoutCheck = _axios({
        url: '/api/balance',
        data: {},
        method: 'POST',
        skipAuthLogout: true,
    }).then(check => {
        const still = getToken()
        const expired = check.data && check.data.code === 401 && still && still === expectedToken
        if (!expired) {
            logoutCheck = null
            return
        }
        Dialog.alert({
            title: '认证失败',
            message: '您的账号登陆过期，请重新登陆',
        }).then(() => {
            if (getToken() === expectedToken) {
                clearAuthStorage()
                store.commit('changUserInfo')
                store.commit('changToken')
                router.replace('/login')
            }
        }).catch(() => {}).then(() => {
            logoutCheck = null
        })
    }).catch(() => {
        logoutCheck = null
    })
}

//封装post,get方法
const http = {
    get(url = '', params = {}) {
        return new Promise((resolve, reject) => {
            _axios({
                url,
                params,
                method: 'GET'
            }).then(res => {
                resolve(res.data)
                return res
            }).catch(error => {
                reject(error)
            })
        })
    },
    post(url = '', params = {}) {
        return new Promise((resolve, reject) => {
            _axios({
                url,
                data: params,
                method: 'POST'
            }).then(res => {
                resolve(res.data)
                return res
            }).catch(error => {
                reject(error)
            })
        })
    }
}


export default http



// WEBPACK FOOTER //
// ./src/http/http.js